export default {"src":"/_next/static/media/jpy.7b0abaff.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};